import React from '@root/vendor/react';

const FormDispatchContext = React.createContext();

export default FormDispatchContext;
